export const StudentQuizProgressByCourseSectionTranslations = {
  PRACTICE: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Jarraitu',
    pt: 'Practicar'
  },
  MY_PROGRESS: {
    es: 'Mi progreso',
    en: 'My progress',
    cat: 'El meu progrés',
    eus: 'Nire progresua',
    pt: 'O meu progresso'
  }
};
